import script from "./HrTree.vue?vue&type=script&setup=true&lang=js"
export * from "./HrTree.vue?vue&type=script&setup=true&lang=js"

import "./HrTree.vue?vue&type=style&index=0&id=9a147d12&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a147d12"]])

export default __exports__
import QTree from 'quasar/src/components/tree/QTree.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTree,QIcon});
